import React from "react";

export const BrandAmplePage: React.FC = () => {
  return (
    <section className="pt-28 pb-20">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl">
          <h1 className="text-3xl md:text-4xl font-semibold text-gray-900">
            Ample
          </h1>
          <p className="mt-4 text-gray-600">
            Content for this brand is coming soon.
          </p>
        </div>
      </div>
    </section>
  );
};

